/**
 * NDL Cart Drawer: overlay close, upsell carousel + add-to-cart with section refresh
 */
(function () {
  document.addEventListener('click', function (e) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (inner && inner.contains(e.target)) return;
    if (e.target.closest('#cart-icon-bubble')) return;
    drawer.close();
  });

  /* Vor Navigation den Drawer-State zurücksetzen, damit BFCache nicht den "active"-Zustand
     samt body.overflow-hidden konserviert. Sonst ist nach Browser-Back das Layout out-of-sync
     (Footer-Sticky-Bug nach Klick auf z. B. den Versandkosten-Link im Footer). */
  window.addEventListener('pagehide', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('active', 'animate');
    }
    document.body.classList.remove('overflow-hidden');
  });

  /* Nach Browser-Back zusätzlicher Cleanup, falls pagehide nicht griff (z. B. iOS-Safari-Edgecases). */
  window.addEventListener('pageshow', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') {
      drawer.close();
    }
    document.body.classList.remove('overflow-hidden');
  });

  function ndlPatchCartDrawerItems(maxTries) {
    var CDI =
      typeof customElements !== 'undefined' && typeof customElements.get === 'function'
        ? customElements.get('cart-drawer-items')
        : null;
    if (CDI && CDI.prototype) {
      CDI.prototype.onCartUpdate = function () {};
      CDI.prototype.getSectionsToRender = function () {
        // Never include cart-icon-bubble — WF header owns the icon/badge markup.
        // Replacing #cart-icon-bubble with Dawn icon-cart-empty was flashing the tiny bag.
        return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' }];
      };
      return;
    }
    if (maxTries <= 0) return;
    setTimeout(function () {
      ndlPatchCartDrawerItems(maxTries - 1);
    }, 50);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ndlPatchCartDrawerItems(20);
    });
  } else {
    ndlPatchCartDrawerItems(20);
  }

  var ndlUpsellSwiperInstance = null;

  function ndlDestroyUpsellSwiper() {
    if (ndlUpsellSwiperInstance && typeof ndlUpsellSwiperInstance.destroy === 'function') {
      try {
        ndlUpsellSwiperInstance.destroy(true, true);
      } catch (err) {
      }
    }
    ndlUpsellSwiperInstance = null;
  }

  function ndlInitUpsellSwiper() {
    var carousel = document.querySelector('[data-ndl-upsell-carousel][data-ndl-upsell-infinite="true"]');
    if (!carousel) {
      ndlDestroyUpsellSwiper();
      return;
    }
    var el = carousel.querySelector('[data-ndl-upsell-swiper]');
    if (!el || typeof window.Swiper !== 'function') return;

    var slideCount = el.querySelectorAll('.swiper-slide').length;
    if (slideCount < 2) return;

    ndlDestroyUpsellSwiper();

    var prevBtn = carousel.querySelector('.ndl-drawer__upsell-prev');
    var nextBtn = carousel.querySelector('.ndl-drawer__upsell-next');

    ndlUpsellSwiperInstance = new window.Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      loopAdditionalSlides: 2,
      watchOverflow: true,
      navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : false,
      a11y: { enabled: true },
      observer: true,
      observeParents: true,
    });
  }

  /* Init sobald das DOM bereit ist und Swiper verfügbar */
  function ndlTryInitSwiper(maxTries) {
    if (typeof window.Swiper === 'function') {
      ndlInitUpsellSwiper();
      return;
    }
    if (maxTries <= 0) return;
    setTimeout(function () {
      ndlTryInitSwiper(maxTries - 1);
    }, 100);
  }

  function ndlUpdateUpsellNav(carousel) {
    if (!carousel) return;
    if (carousel.getAttribute('data-ndl-upsell-infinite') === 'true') return;
    var track = carousel.querySelector('[data-ndl-upsell-track]');
    var prev = carousel.querySelector('.ndl-drawer__upsell-prev');
    var next = carousel.querySelector('.ndl-drawer__upsell-next');
    if (!track || !prev || !next) return;

    var max = track.scrollWidth - track.clientWidth;
    var x = track.scrollLeft;
    var tol = 2;
    var noOverflow = max <= tol;
    var atStart = x <= tol;
    var atEnd = x >= max - tol;

    prev.classList.toggle('is-edge', noOverflow || atStart);
    next.classList.toggle('is-edge', noOverflow || atEnd);
  }

  function ndlBindUpsellNav() {
    var carousels = document.querySelectorAll('[data-ndl-upsell-carousel]');
    carousels.forEach(function (carousel) {
      if (carousel.getAttribute('data-ndl-upsell-infinite') === 'true') return;
      var track = carousel.querySelector('[data-ndl-upsell-track]');
      if (!track) return;
      if (!track.dataset.ndlNavBound) {
        track.dataset.ndlNavBound = '1';
        track.addEventListener(
          'scroll',
          function () {
            ndlUpdateUpsellNav(carousel);
          },
          { passive: true }
        );
      }
      ndlUpdateUpsellNav(carousel);
    });
  }

  var ndlNavResizeTimer = null;
  window.addEventListener('resize', function () {
    if (ndlNavResizeTimer) clearTimeout(ndlNavResizeTimer);
    ndlNavResizeTimer = setTimeout(ndlBindUpsellNav, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ndlTryInitSwiper(20);
      ndlBindUpsellNav();
    });
  } else {
    ndlTryInitSwiper(20);
    ndlBindUpsellNav();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(ndlInitUpsellSwiper, 80);
    });
  }
  function getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function refreshDrawerFromSections(sections) {
    if (!sections) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (sections['cart-drawer'] && cartDrawer) {
      const inner = getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      const target = document.querySelector('#CartDrawer');
      if (target && inner) {
        target.innerHTML = inner;
        var hasEmptyInner = !!target.querySelector('.drawer__inner-empty');
        cartDrawer.classList.toggle('is-empty', hasEmptyInner);
        const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.addEventListener('click', function handler() {
            cartDrawer.close();
          });
        }
      }
    }

    // WF header owns cart badges — skip Dawn cart-icon-bubble HTML replacement.

    if (typeof publish === 'function') {
      publish('cart-update', { source: 'ndl-cart-drawer-upsell' });
    }

    setTimeout(ndlInitUpsellSwiper, 50);
    setTimeout(ndlBindUpsellNav, 60);
  }

  document.addEventListener('click', function (e) {
    const carousel = e.target.closest('[data-ndl-upsell-carousel]');
    if (!carousel) return;
    if (carousel.getAttribute('data-ndl-upsell-infinite') === 'true') return;

    const prev = e.target.closest('.ndl-drawer__upsell-prev');
    const next = e.target.closest('.ndl-drawer__upsell-next');
    const track = carousel.querySelector('[data-ndl-upsell-track]');
    if (!track) return;

    if (prev) {
      e.preventDefault();
      const card = track.querySelector('.ndl-upsell-card');
      const w = card ? card.offsetWidth + 16 : 280;
      track.scrollBy({ left: -w, behavior: 'smooth' });
    }
    if (next) {
      e.preventDefault();
      const card = track.querySelector('.ndl-upsell-card');
      const w = card ? card.offsetWidth + 16 : 280;
      track.scrollBy({ left: w, behavior: 'smooth' });
    }
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ndl-upsell-card__add');
    if (!btn || btn.disabled) return;
    const drawer = btn.closest('cart-drawer');
    if (!drawer) return;

    e.preventDefault();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    const sectionsUrl = typeof window.location.pathname === 'string' ? window.location.pathname : '/';

    fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: sectionsUrl,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status === 422 || data.description) {
          console.warn('Cart add:', data);
          return;
        }
        if (data.sections) {
          refreshDrawerFromSections(data.sections);
        }
        setTimeout(function () {
          if (typeof data.total_price === 'number' && typeof window.ndlSyncFreeShippingBarFromCart === 'function') {
            window.ndlSyncFreeShippingBarFromCart(data.total_price);
          }
        }, 50);
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = originalText;
      });
  });
})();
